define('ProductTile/productTileComponent',[
    "common/urlUtils"
],
function (urlUtils) {

    function initClickHandlers() {
        $(".product-tile .variant-selector .color-selector .selector").off("click").on("click", colorSelectorClicked);
        $(".product-tile .variant-selector .list-selector").off("change").on("change", listSelectorChanged);
    }

    const selectorType = {
        color: 1,
        list: 2
    };

    function colorSelectorClicked(event) {
        $(this).siblings().removeClass("active");     // deactivate all other selectors
        if ($(this).hasClass("active")) {
            // It was already active. Deactivate it now.
            $(this).removeClass("active");
            setVariant(this, { variantSku: ""});    // set to the default variant (no particular variant selected)
        }
        else {
            // activate the clicked selector
            $(this).addClass("active");
            setVariant(this, $(this).data());   // set to the variant data written in that selector
        }
    }

    function listSelectorChanged(event) {

        setVariant(this, $(this.selectedOptions[0]).data());
        //selectVariant(this, selectorType.list);
    }

    function setVariant(clickedElement, variantData) {
        var imageElement = $(clickedElement).closest(".product-tile").find("img");
        if (!$(imageElement).data("originalSrc")) {
            // store original image url, in case we need to put it back
            $(imageElement).data("originalSrc", $(imageElement).attr("src"));
        }
        var currentImageUrl = $(imageElement).attr("src");
        var newImageUrl = $(imageElement).data("originalSrc");  // this is the default image

        var linkElement = $(clickedElement).closest(".product-tile").find("a");

        if (variantData.variantSku) {
            if (variantData.imageUrl) newImageUrl = variantData.imageUrl;
            urlUtils.pushParamIntoLink("v", variantData.variantSku, linkElement);   // add variant query parameter into the link
        } else {
            urlUtils.popParamFromLink("v", linkElement);   // remove variant query parameter from link
        }

        if (newImageUrl !== currentImageUrl) {
            $(imageElement)
                .addClass("opacity-05")                        // dim the image
                .one("load", function () {
                    $(this).removeClass("opacity-05");         // set the load event to un-dim the image
                })
                .attr("src", newImageUrl)                      // change the image source
                .each(function () {
                    // Workaround for situations where the load event doesn't get triggerred because the image is taken from cache, or the
                    // image changes so quickly that our "onload" event didn't have a chance to be set up yet.
                    setTimeout(() => { $(imageElement).removeClass("opacity-05"); }, 2000);  // just in case "onload" didn't do it already, we'll clear the opacity class after 2 seconds
                });
        }

        $(linkElement).data("variantSku", variantData.variantSku);   // this will be used by the GTM click event
    }

    function selectVariant(clickedElement, selectorType) {

        var imageElement = $(clickedElement).closest(".product-tile").find("img");
        if (!$(imageElement).data("originalSrc")) {
            // store original image url, in case we need to put it back
            $(imageElement).data("originalSrc", $(imageElement).attr("src"));
        }

        var newImageUrl = $(imageElement).data("originalSrc");  // this is the default image

        if (selectorType === selectorType.color) {
            $(clickedElement).siblings().removeClass("active");     // deactivate all other selectors
        }

        var linkElement = $(clickedElement).closest(".product-tile").find("a");

        if ($(clickedElement).hasClass("active")) {
            // It was already active. Deactivate it now.
            $(clickedElement).removeClass("active");
            // remove the variant query parameter from the link
            urlUtils.popParamFromLink("v", linkElement);
        }
        else
        {
            // activate the clicked selector
            $(clickedElement).addClass("active");
            // and apply its image, if it has one assigned
            if ($(clickedElement).data("imageUrl")) newImageUrl = $(clickedElement).data("imageUrl");
            // add the selected variant query parameter into the link
            var variantSku = $(clickedElement).data("variantSku");
            if (variantSku) urlUtils.pushParamIntoLink("v", variantSku, linkElement);
        }

        $(imageElement).attr("src", newImageUrl);
    }

    return {
        initClickHandlers: initClickHandlers
    };

});
